import React, { Component } from 'react';
import { getCommentsListPaginate, removeCommentItem, editCommentItem } from '../../modules/Api';
import ReactTable from 'react-table'
// import history from '../../modules/History';
import { notification, Switch, Select } from 'antd';
import {ACL, getAuthUserInfo, userHasPermission} from '../../components/ACL';

const { Option } = Select;

class Stores extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
            user_info: getAuthUserInfo()
        }
    }
    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getCommentsListPaginate(query, (data) => {this.setState({
            items: data.data,
            count: data.total,
            last_page: data.last_page,
            pageSize: data.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        const id = state.filtered.find(f => f.id === 'id') ? state.filtered.find(f => f.id === 'id').value : '';
        const name = state.filtered.find(f => f.id === 'name') ? state.filtered.find(f => f.id === 'name').value : '';
        const entity_id = state.filtered.find(f => f.id === 'entity_id') ? state.filtered.find(f => f.id === 'entity_id').value : '';
        const status = state.filtered.find(f => f.id === 'status') ? state.filtered.find(f => f.id === 'status').value : '';
        const comment = state.filtered.find(f => f.id === 'comment') ? state.filtered.find(f => f.id === 'comment').value : '';
        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&name=${name}&entity_id=${entity_id}&status=${status}&id=${id}&comment=${comment}`;


        this.fetchData(query);
    }
    canEdit(permission = "comments_management|comments_edit") {
        return userHasPermission(this.state.user_info.roles, this.state.user_info.permissions, permission);
    }

    changeStatus(id, status) {
        if(!this.canEdit()){
            notification.open({
                message: `دسترسی ویرایش ندارید!`,
            });
            return
        }
        
        // 1. Make a shallow copy of the items
        let items = [...this.state.items];
        // // 2. Make a shallow copy of the item you want to mutate
        const index = Object.keys(items).find(key => items[key].id === id)
        let item = {...items[index]};
        // // 3. Replace the property you're intested in
        item.status = status;
        // // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // // 5. Set the state to our new copy
        this.setState({items});

        editCommentItem(id, {
            'status' : status
        }, () => {})
    }

    removeComment(id) {
        const warningMessage = `آیا از حذف این کامنت اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        if (window.confirm(warningMessage)) {
            removeCommentItem(id, () => {
                this.fetchData();
                notification.open({
                    message: `کامنت با موفقیت حذف شد!`,
                    description: `این کامنت و تمام پاسخ‌های مربوط به آن حذف شد`
                })
            })
        }
    }
    render() {
        const self = this;
        const columns = [
            {
                Header: 'آیدی',
                filterable: true,
                sortable: true,
                accessor: 'id',
                width: 70
            },
            {
                filterable: true,
                Header: 'نام',
                accessor: 'name',
                sortable: true,
                Cell: (row) => (
                    <span
                        // style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}}
                        title={row.original.name}
                        // onClick={() => {history.item.push(`/comments/edit/${row.original.id}`)}}
                    >
                        {row.original.name}
                    </span>
                ),
                style: {
                    textAlign: 'right'
                }
            },
            {
                Header: 'عنوان',
                accessor: 'entity_name',
                Cell: (row) => (
                    <span
                        // style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}}
                        title={row.original.entity_name}
                        // onClick={() => {history.item.push(`/comments/edit/${row.original.id}`)}}
                    >
                        {row.original.entity_name}
                    </span>
                ),
                style: {
                    textAlign: 'right'
                }
            },
            {
                Header: 'شناسه',
                    filterable: true,
                sortable: true,
                accessor: 'entity_id',
                width: 70
            },
            {
                filterable: true,
                Header: 'ایمیل',
                accessor: 'email',
                sortable: true,
                Cell: (row) => (
                    <span title={row.original.email}>
                        {row.original.email}
                    </span>
                ),
                style: {
                    textAlign: 'right',
                }
            },
            {
                filterable: true,
                Header: 'نظر',
                accessor: 'comment',
                Cell: (row) => (<span title={row.original.comment}> {row.original.comment} </span>),
                style: {
                    whiteSpace: 'break-spaces',
                    textAlign: 'right',
                },
                width: 400
            },
            {
                Header: 'وضعیت',
                accessor: 'status',
                filterable: true,
                Cell: function(row) {
                    return (
                        <div>
                            <Select
                                style={{ width: "100%", direction: 'rtl' }}
                                onChange={function(value){ self.changeStatus(row.original.id, value); }}
                                value={row.original.status}
                            >
                                <Option style={{textAlign: 'right'}} value={0}>رد شده</Option>
                                <Option style={{textAlign: 'right'}} value={1}>مورد قبول</Option>
                                <Option style={{textAlign: 'right'}} value={2}>منتظر</Option>
                            </Select>
                        </div>
                    );
                },
                Filter: ({ filter, onChange }) =>
                <Select
                    onChange={value => onChange(value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : ""}
                >
                    <Option value="">همه</Option>
                    <Option value="0">رد شده</Option>
                    <Option value="1">مورد قبول</Option>
                    <Option value="2">منتظر</Option>
                </Select>,
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="comments_management|comments_delete"><span onClick={() => {this.removeComment(row.original.id)}} style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X</span></ACL>
                    </React.Fragment>
                )
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}
                />
            </div>
        );
    }
}

export default Stores;


// WEBPACK FOOTER //
// ./src/containers/Comments/index.js